import { render, staticRenderFns } from "./satis_ekle.vue?vue&type=template&id=0f9b5e63&"
import script from "./satis_ekle.vue?vue&type=script&lang=js&"
export * from "./satis_ekle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports